import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import PersonnelAdjustment from 'features/Project/pages/PersonnelAdjustment';

function PersonnelAdjustmentEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <PersonnelAdjustment isEdit />
      </Layout>
    </LayoutProvider>
  );
}

export default PersonnelAdjustmentEditPage;
